export default {
  'novice.banner_desc': 'Make sure to complete the following tasks within 30 days to get your rewards!',
  'novice.banner_title': 'Welcome to Our Beginner tasks!',
  'novice.step_title_1': 'Register',
  'novice.step_desc_1': 'Win up to {reward_amount} {reward_asset} after registering',
  'novice.step_desc_2': 'Win up to {reward_amount} {reward_asset} after completing KYC',
  'novice.step_desc_3': 'Win up to {reward_amount} {reward_asset} after depositing {base_amount} {base_asset}',
  'novice.step_desc_4': "You'll get {reward_amount} {reward_asset} reward for spot trading",
  'novice.step_title_5': 'Invite & Get Rebates',
  'novice.step_desc_5':
    'New registration within 7 days of inviting friends to increase the commission fee to 40%, and share the $50000 BIT bonus pool',
  'novice.with': 'With <span>Biconomy</span>, earning is easy for everyone!',
  'novice.faq_title_1': 'How do I get the rewards inside the newbie benefits?',
  'novice.faq_desc_1':
    'A: When you complete the above tasks, the rewards will be activated automatically, click to get it, and the rewards will be issued to your spot account.',
  'novice.faq_title_2': 'Why do some tasks show expired?',
  'novice.faq_desc_2':
    'A: The above tasks are only valid for new users to complete within 30 days after registration, and you need to collect the rewards within the validity period, otherwise, the tasks may expire or the rewards may expire and cannot be collected.',
  'novice.faq_title_3': 'Why am I not eligible to participate?',
  'novice.faq_desc_3':
    'The above tasks are only available to new users who have registered after the newbie benefits have gone live and meet the conditions required in the tasks to get the rewards.',
  'novice.claim': 'Claim',
  'novice.claimed': 'Claimed',
  'novice.finishing': 'Go',
  'novice.invite': 'Invite',
  'novice.reward': 'Up to {reward_amount} {reward_asset} in reward',
  'novice.traded': 'Trading volume ≥ {baseAmount} {baseAsset}',

  'Congratulations': 'Congratulations',
  'novice.get': 'Get',
  'novice.modal_tip': 'It has been transferred to your spot wallet.',
};
